import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import Toastify from "../helper/Toastify";
import api from "../helper/Api";



export const getProfile = createAsyncThunk('getProfile', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.getProfile();
        // console.log('data', data);

        if (status === 200) {
            dispatch(setLoggedin(true))

        }
        return data.data
    } catch (err) {
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)

export const updateProfileThunk = createAsyncThunk('updateProfile', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.updateProfile(body);

        if (status === 200) {
            dispatch(setUserData(data.data));
            // Toastify.success("Profile update successful")
            dispatch(setUserRefresh())
            return status
        }
    } catch (err) {
        Toastify.error(err.response.data.message || "'Something went wrong. Please try again later.'")

    }
}
)

export const deleteProfileImageThunk = createAsyncThunk(
    'deleteProfileImage',
    async (_, { rejectWithValue, dispatch }) => {
        try {
            const { status } = await api.deleteProfileImage();

            if (status === 200) {
                dispatch(setUserRefresh());
                // Toastify.success("Image deleted successfully");
            }
        } catch (err) {
            Toastify.error(err.response?.data?.message || "Deletion failed");
            return rejectWithValue(err.response.data);
        }
    }
);

export const addShippingAddressThunk = createAsyncThunk('addShippingAddressThunk', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.addShippingAddress(body);

        if (status === 200) {
            // Toastify.success("Address Added successfully successful")
            dispatch(setUserRefresh())
            return status
        }

    } catch (err) {
        Toastify.error(err.response.data.message || "'Something went wrong. Please try again later.'")

    }
}
)


export const editShippingAddressThunk = createAsyncThunk('editShippingAddressThunk', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.editShippingAddress(body);

        if (status === 200) {
            // Toastify.success("Address Edited successfuly")
            dispatch(setUserRefresh())
            return status
        }

    } catch (err) {
        Toastify.error(err.response.data.message || "'Something went wrong. Please try again later.'")

    }
}
)
export const deleteShippingAddress = createAsyncThunk('deleteShippingAddress', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.deleteShippingAddress(body);

        if (status === 200) {
            // Toastify.success("Address Deleted successfuly")
            dispatch(setUserRefresh())
            return status
        }

    } catch (err) {
        Toastify.error(err.response.data.message || "'Something went wrong. Please try again later.'")

    }
}
)
export const deleteBillingAddress = createAsyncThunk('deleteBillingAddress', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.deleteBillingAddress(body);

        if (status === 200) {
            // Toastify.success("Address Deleted successfuly")
            dispatch(setUserRefresh())
            return status
        }

    } catch (err) {
        Toastify.error(err.response.data.message || "'Something went wrong. Please try again later.'")

    }
}
)
export const resetUnreadCountsThunk = createAsyncThunk('resetUnreadCounts', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.resetUnreadCounts(body);

        if (status === 200) {
            // Toastify.success("Address Edited successfully successful")
            dispatch(setUserRefresh())
            // return status
        }

    } catch (err) {
        console.log(err);

        // Toastify.error(err.response.data.message || "'Something went wrong. Please try again later.'")

    }
}
)

export const addContactUs = createAsyncThunk('contactUs', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.contactUs(body);

        if (status === 200) {
            Toastify.success("Message sent successfully")
            dispatch(setUserRefresh())
            return status
        }

    } catch (err) {
        Toastify.error(err.response?.data?.message || "Something went wrong. Please try again later.");
        return rejectWithValue(err.response?.data);
    }
});

export const verifyUpdateProfileOtp = createAsyncThunk("verifyUpdateProfileOtp", async (body, { rejectWithValue, dispatch }) => {
    try {

        const { data, status } = await api.verifyEditProfileOtp(body);


        console.log("daaaata", data)

        if (status === 200) {
            dispatch(setUserData(data.data));
            dispatch(setUserRefresh())
            return data.data;
        }

    } catch (error) {
        Toastify.error(error.response.data.message)
        console.log("errr---------", error)
        return rejectWithValue(error.response.data.message || "'Something went wrong. Please try again later.'")
    }
})
const initialState = {
    isLoggedIn: false,
    user: {},
    data: null,
    errorMsg: "",
    isError: false,
    token: null,
    refresh: false,
    isLoading: false
}


const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setLoggedin: (state, action) => {
            state.isLoggedIn = action.payload
        },
        // setTwoFA: (state, action) => {
        //     state.user["2FA"] = action.payload
        // },
        setLogOut: (state, action) => {
            state.isLoggedIn = false
            state.user = {}
            state.token = ""
        },
        setLoginData: (state, action) => {
            state.data = action.payload
        },
        setToken: (state, action) => {
            state.token = action.payload
        },
        setUserData: (state, action) => {
            state.user = action.payload
        },
        setUserRefresh: (state, action) => {
            state.refresh = !state.refresh
        }

    },
    extraReducers: (builder) => {
        // login
        builder.addCase(getProfile.pending, (state) => {
            state.isLoading = true

        })
        builder.addCase(getProfile.fulfilled, (state, action) => {
            state.isLoading = false
            state.user = action.payload
        })
        builder.addCase(getProfile.rejected, (state, action) => {
            state.isLoading = false
            state.errorMsg = action.payload
        })
    }
})

export const { setLoggedin, setTwoFA, setLogOut, setLoginData, setToken, setUserData, setUserRefresh } = userSlice.actions

export default userSlice.reducer